interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function getPageItems(page: number, totalPages: number): (number | string)[] {
  const items: (number | string)[] = [];
  const push = (value: number | string) => items.push(value);
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i += 1) push(i);
    return items;
  }
  push(1);
  if (page > 3) push("left-ellipsis");
  const start = Math.max(2, page - 1);
  const end = Math.min(totalPages - 1, page + 1);
  for (let i = start; i <= end; i += 1) push(i);
  if (page < totalPages - 2) push("right-ellipsis");
  push(totalPages);
  return items;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const items = getPageItems(page, totalPages);

  return (
    <div className="flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line text-lg" />
      </button>
      {items.map((item) =>
        typeof item === "number" ? (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            className={`flex h-9 min-w-9 cursor-pointer items-center justify-center rounded-md border px-2 text-sm font-medium transition-colors ${
              item === page
                ? "border-primary-500 bg-primary-500 text-background-50"
                : "border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {item}
          </button>
        ) : (
          <span key={item} className="px-1 text-foreground-400">
            ···
          </span>
        ),
      )}
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </div>
  );
}